import { Popup } from "react-leaflet";
import './MapPopup.css'

const MapPopup = ({cityName, pinCount}) => {
    const locations = `${pinCount} ${pinCount === 1 ? ' Location' : ' Locations'}`;

    return (
        <Popup closeButton={false} className="popup_custom" >
            <div className="popup_content_wrapper">
                <div style={{fontWeight: 'bold'}}>{cityName}</div>
                <div className="popup_vertical_line"></div>
                <div>{locations}</div>
            </div>
        </Popup>
    )
}

export default MapPopup;